import { render, staticRenderFns } from "./NewSchool.vue?vue&type=template&id=cc1913c8&scoped=true"
import script from "./NewSchool.vue?vue&type=script&lang=js"
export * from "./NewSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1913c8",
  null
  
)

export default component.exports